import { ISalesman } from "@/models/ISalesman";
import { ILink } from "@/models/ILink";

export class Salesman implements ISalesman {
  fullName?: string;
  title?: string;
  moreInfoText?: string;
  image1Url?: string;
  image2Url?: string;
  phoneNumber?: string;
  email?: string;
  linkedInUrl?: string;
  role?: string;
  linkToPageOnGreen?: ILink;
  linkToPageOnBlue?: ILink;
  quote?: string;
  zipCodes?: Array<string>;
  districtCode?: string;
  isDefault?: boolean;
}
